import React from 'react';
import StopCommentsCell from './component';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['comments'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { comments } = props.selectors.getJourneyStopFields(
      state,
      props.journeyId,
      props.stopId,
      fields
    );
    const hasComments = !!comments.length;

    return {
      comments,
      hasComments,
    };
  }),
  withHandlers({
    handleRenderComments:
      ({ comments = [] }) =>
      () => {
        return comments.map((comment, key) => <div key={key}>{comment}</div>);
      },
  })
);

export default enhance(StopCommentsCell);
